import config from 'app/config'
/**
 * whether the url is sent by main host
 * @param url
 */
export function isMainHost (url) {
  return url.includes(config.backend)
}

export function redirectLogin () {
  window.location.href = `${config.urlPrefix}/start/login`
}



// WEBPACK FOOTER //
// ./src/app/utils/requestUtils.js